import { QueryClient, useQuery } from '@tanstack/react-query';
import { ActivityPointApi } from 'api/ApiHelper';
import { activityPointQueryKey } from 'queries/activityPoint/queryKey';

export const useGetActivityPointAllRankQuery = () =>
  useQuery({ queryKey: activityPointQueryKey.activityPointAllRank(), queryFn: () => ActivityPointApi.getAllRank() });

export const prefetchGetActivityPointAllRankQuery = async (queryClient: QueryClient) =>
  queryClient.prefetchQuery({
    queryKey: activityPointQueryKey.activityPointAllRank(),
    queryFn: () => ActivityPointApi.getAllRank(),
  });
